import { render, staticRenderFns } from "./VolcanoPlot.vue?vue&type=template&id=282bb98b&"
import script from "./VolcanoPlot.vue?vue&type=script&lang=js&"
export * from "./VolcanoPlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports